import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app.component';
import { HospitalLanguageService } from './core/i18n/hospital-language.service';
import { LayoutModule } from './layout/layout.module';
import { RoutesModule } from './routes/routes.module';
import { SharedModule } from './shared/shared.module';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule } from '@angular/material/form-field';
import { ApiModule } from './core/api/api.module';
import { provideCharts, withDefaultRegisterables, } from 'ng2-charts';

export function initHospitalLanguage(lang: HospitalLanguageService) {
  return () => lang.load();
}

@NgModule({
    declarations: [
        AppComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        MatFormFieldModule,
        // ルートモジュール
        RoutesModule,
        // 共有モジュール
        SharedModule,
        // レイアウトモジュール
        LayoutModule,
        NoopAnimationsModule,
        ApiModule], providers: [
            // FORM_FIELDのグローバル設定
            {
                provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
                useValue: {
                    floatLabel: 'always',
                    appearance: 'outline',
                    color: 'accent',
                }
            },
            provideHttpClient(withInterceptorsFromDi()),
            provideCharts(withDefaultRegisterables()),
            {
              provide: APP_INITIALIZER,
              useFactory: initHospitalLanguage,
              deps: [HospitalLanguageService],
              multi: true,
            },
        ]
})

export class AppModule { }
